import { IApplicationState } from '../../types/redux';
import { DEFAULT_REGION } from '../../constants/regions';

export function getRegion(state: IApplicationState) {
  const { tab } = state;

  return state.geo.locationsMap[tab] || DEFAULT_REGION;
}
